import { Card } from 'primereact/card';
import { Chart } from 'primereact/chart';
import { Divider } from 'primereact/divider';
import React, { useEffect, useState } from 'react';

import GroupOne from '../../../assets/gamePlan/group-427323555.png';
import GroupTwo from '../../../assets/gamePlan/group-427323554.png';
import MaskGroup from '../../../assets/gamePlan/mask-group.png';
import FaceIcon from '../../../assets/gamePlan/SmileFaceBlue.png';
import { gamePlanColors, GameplanProps } from '../gamePlanType';
import Vector13 from '../../../assets/gamePlan/vector-13.svg';
import Vector14 from '../../../assets/gamePlan/vector-14.svg';
import Vector15 from '../../../assets/gamePlan/vector-15.svg';
import Vector17 from '../../../assets/gamePlan/vector-17.svg';
import PlanetA from '../../../assets/gamePlan/planeta.png';
import PlanetB from '../../../assets/gamePlan/planetb.png';
import PlanetB1 from '../../../assets/gamePlan/planetb-1.png';
import PlanetC from '../../../assets/gamePlan/planetc.png';

export const GameplanBannerSection = ({ gamePlan }: GameplanProps): JSX.Element => {
    const [chartData, setChartData] = useState<any>({});
    const [chartOptions, setChartOptions] = useState<any>({});
    const [gamePlanData, setGamePlanData] = useState<any>();
    const [teamStats, setTeamStats] = useState<any>([{}]);

    useEffect(() => {
        setGamePlanData(gamePlan);
    }, [gamePlan]);

    useEffect(() => {
        if (gamePlanData?.data?.length > 0) {
            const countByActionId = gamePlanData?.data?.reduce((acc: any, item: any) => {
                const actionId = item.gameplan_action_id;
                if (typeof actionId === 'number') {
                    return {
                        ...acc,
                        [actionId]: (acc[actionId] || 0) + 1,
                    };
                }
                return acc;
            }, {});

            const actionMapping: Record<string, { label: string; color: string }> = {
                'No Data Available': { label: 'No Data', color: gamePlanColors.noData },
                Coach: { label: 'Needs Coaching', color: gamePlanColors.coach },
                Recognize: { label: 'Deserves Recognition', color: gamePlanColors.recognize },
            };

            // Dynamically build actionDetails
            const actionDetails: Record<number, { label: string; color: string }> = {};

            gamePlanData?.data?.forEach((item: any) => {
                const id = item.gameplan_action_id;
                const name = item.gameplan_action_name;

                if (!actionDetails[id] && actionMapping[name]) {
                    actionDetails[id] = actionMapping[name];
                }
            });

            // const actionDetails: Record<number, { label: string; color: string }> = {
            // 1: { label: 'Deserves Recognition', color: gamePlanColors.recognize },
            // 2: { label: 'Needs Coaching', color: gamePlanColors.coach },
            // 3: { label: 'No Data', color: gamePlanColors.noData },
            // };

            const totalCount = Number(gamePlanData?.data?.length) || 0;
            const stats = Object.entries(countByActionId).map(([actionIdStr, count]) => {
                const actionId = parseInt(actionIdStr, 10);
                const safeCount = Number(count) || 0;
                const details = actionDetails[actionId];
                const percentage = totalCount > 0 ? Number(((safeCount / totalCount) * 100).toFixed(2)) : 0;
                return {
                    percentage,
                    label: details?.label || 'Unknown',
                    color: details?.color || '#000',
                };
            });
            setTeamStats(stats);

            const score = Object.values(countByActionId);
            const backgroundColors = Object.keys(countByActionId).map((actionIdStr) => {
                const actionId = parseInt(actionIdStr, 10);
                return actionDetails[actionId]?.color || '#000';
            });

            const data = {
                datasets: [
                    {
                        data: score,
                        label: 'Recommendation',
                        backgroundColor: backgroundColors,
                        hoverBackgroundColor: backgroundColors,
                    },
                ],
            };
            const options = {
                cutout: '60%',
            };
            setChartData(data);
            setChartOptions(options);
        } else setChartData([]);
    }, [gamePlanData]);

    return (
        <Card
            className="gameplan-banner"
            style={{
                height: '502px',
                borderRadius: '30px',
                position: 'relative',
                overflow: 'hidden',
                margin: '32px 0',
            }}
        >
            {/* Gradient background */}
            <div
                style={{
                    position: 'absolute',
                    inset: 0,
                    borderRadius: '30px',
                    background:
                        'linear-gradient(270deg, rgba(99,74,226,0.8) 0%, rgba(200,134,211,0.8) 50%, rgba(0,214,187,0.8) 86%)',
                }}
            />

            {/* Background decorative images */}
            <div style={{ position: 'relative', height: '100%', width: '100%' }}>
                <div
                    style={{
                        position: 'absolute',
                        width: '1523px',
                        height: '476px',
                        top: '12px',
                        right: '133px',
                        transform: 'rotate(180deg)',
                    }}
                >
                    <img
                        style={{
                            position: 'absolute',
                            width: '1523px',
                            height: '223px',
                            top: '253px',
                            left: 0,
                            transform: 'rotate(180deg)',
                        }}
                        alt="Background pattern"
                        src={GroupOne}
                    />
                    <img
                        style={{
                            position: 'absolute',
                            width: '1226px',
                            height: '389px',
                            top: 0,
                            left: '300px',
                            transform: 'rotate(180deg)',
                        }}
                        alt="Background pattern"
                        src={GroupTwo}
                    />
                </div>

                {/* Title */}
                <div
                    style={{
                        position: 'absolute',
                        top: '24px',
                        left: '36px',
                        fontFamily: 'Urbanist',
                        fontWeight: 'bold',
                        color: 'white',
                        fontSize: '64px',
                    }}
                >
                    Gameplan
                </div>

                {/* Planet decorations */}
                <div
                    style={{
                        position: 'absolute',
                        width: '217px',
                        height: '157px',
                        top: '8px',
                        right: '217px',
                    }}
                >
                    <img
                        style={{
                            position: 'absolute',
                            width: '157px',
                            height: '157px',
                            top: 0,
                            left: '30px',
                        }}
                        alt="Vector"
                        src={Vector15}
                    />
                    <img
                        style={{
                            position: 'absolute',
                            width: '111px',
                            height: '111px',
                            top: '23px',
                            left: '53px',
                        }}
                        alt="Vector"
                        src={Vector14}
                    />
                    <img
                        style={{
                            position: 'absolute',
                            width: '111px',
                            height: '107px',
                            top: '27px',
                            left: '53px',
                        }}
                        alt="Planet"
                        src={PlanetB}
                    />
                    <img
                        style={{
                            position: 'absolute',
                            width: '55px',
                            height: '84px',
                            top: '38px',
                            left: '90px',
                        }}
                        alt="Planet"
                        src={PlanetC}
                    />
                    <img
                        style={{
                            position: 'absolute',
                            width: '188px',
                            height: '71px',
                            top: '45px',
                            left: '14px',
                        }}
                        alt="Vector"
                        src={Vector13}
                    />
                    <img
                        style={{
                            position: 'absolute',
                            width: '188px',
                            height: '71px',
                            top: '45px',
                            left: '14px',
                        }}
                        alt="Planet"
                        src={PlanetB1}
                    />
                    <img
                        style={{ position: 'absolute', width: '217px', height: '83px', top: '38px', left: 0 }}
                        alt="Vector"
                        src={Vector17}
                    />
                    <img
                        style={{ position: 'absolute', width: '217px', height: '83px', top: '38px', left: 0 }}
                        alt="Planet"
                        src={PlanetA}
                    />
                </div>

                {/* Bottom wave image */}
                <img
                    style={{
                        position: 'absolute',
                        width: '103%',
                        height: '373px',
                        bottom: '-35px',
                        left: '-27px',
                    }}
                    alt="Wave background"
                    src={MaskGroup}
                />

                <div
                    style={{
                        position: 'relative',
                        zIndex: 10,
                        display: 'flex',
                        justifyContent: 'space-between',
                        height: '100%',
                        paddingTop: '230px',
                        padding: '230px 24px 24px',
                    }}
                >
                    {/* Left section with avatar and text */}
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '48px', width: '1102px' }}>
                        <img style={{ width: '150px', height: '150px' }} alt="Avatar" src={FaceIcon} />

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <h2
                                style={{
                                    fontFamily: 'Urbanist',
                                    fontWeight: 'bold',
                                    color: '#3f5765',
                                    fontSize: '24px',
                                }}
                            >
                                What Is Gameplan
                            </h2>

                            <p style={{ fontFamily: 'Urbanist', fontSize: '24px' }}>
                                <span style={{ color: '#3f5765', fontWeight: '400' }}>
                                    Hello! Gameplan is designed to identify a recommended action for your
                                    associates based on their recent metric performance. If an associate is
                                    attaining all the metrics on their scorecard, it will highlight the metric
                                    in which they are excelling the most for{' '}
                                </span>
                                <span style={{ fontWeight: 'bold', color: '#c90370' }}> recognition.</span>
                                <span style={{ color: '#3f5765', fontWeight: '400' }}>
                                    {' '}
                                    If not, it will recommend a metric for
                                </span>
                                <span style={{ fontWeight: 'bold', color: '#f15523' }}> coaching.</span>
                            </p>
                        </div>
                    </div>
                    <Divider
                        style={{
                            height: '210px',
                            margin: '0 0px',
                            width: '110px',
                            transform: 'rotate(270deg)',
                        }}
                    />

                    {/* Right section with team stats */}
                    <div style={{ width: '460px' }}>
                        <h3
                            style={{
                                fontFamily: 'Urbanist',
                                fontWeight: 'bold',
                                color: '#2b3a42',
                                fontSize: '24px',
                                textAlign: 'center',
                                marginBottom: '16px',
                            }}
                        >
                            {gamePlanData?.data?.length !== 0 ? 'Team Stats' : ''}
                        </h3>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                            {/* Chart container */}
                            <div style={{ position: 'relative', width: '202px', height: '202px' }}>
                                <div className="card flex justify-content-center border-0">
                                    <Chart
                                        type="doughnut"
                                        data={chartData}
                                        options={chartOptions}
                                        className="w-full md:w-30rem"
                                    />
                                </div>
                            </div>

                            {/* Legend */}
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                {gamePlanData?.data?.length !== 0 &&
                                    teamStats?.map((stat: any, index: number) => (
                                        <div
                                            key={index}
                                            style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
                                        >
                                            <div
                                                style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    borderRadius: '15px',
                                                    backgroundColor: stat.color,
                                                }}
                                            />
                                            <p
                                                style={{
                                                    fontFamily: 'Urbanist',
                                                    color: '#3f5765',
                                                    fontSize: '14px',
                                                    lineHeight: '20px',
                                                    paddingTop: '5px',
                                                }}
                                            >
                                                <span style={{ fontWeight: 'bold' }}>{stat.percentage}%</span>
                                                <span> - {stat.label}</span>
                                            </p>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};
